import { combineReducers } from "redux";
import {
  pickerReducer,
  PICKER_REDUCER_KEY,
  REDUCER_KEY as VENDOR_REDUCER,
  vendorReducer,
} from "../components/vendor/vendor-reducer";
import {
  REDUCER_KEY as PRINT_TAGS_REDUCER,
  printTagsReducer,
} from "../components/printTags/printTags-reducer";
import {
  openPullReducer,
  REDUCER_KEY as OPEN_PULL_REDUCER,
} from "../components/openPulls/openPull-reducer";
import {
  framePickReducer,
  REDUCER_KEY as FRAME_PICK_REDUCER,
} from "../components/framePick/reducer";
import {
  specialOrderQueueReducer,
  REDUCER_KEY as SPECIAL_ORDER_QUEUE_REDUCER_KEY,
} from "../components/framePick/SpecialOrderQueue/reducer";
import {
  replenishmentReducer,
  REDUCER_KEY as DC_REPLENISHMENT_REDUCER,
} from "../components/Replenishment/reducer";
import {
  REDUCER_KEY as VENDOR_ORDER_REDUCER,
  vendorOrderReducer,
  pendingOrderReducer,
  PENDING_ORDER_REDUCER_KEY,
} from "../components/vendorOrders/reducer";
import {
  REDUCER_KEY as ORDER_STATUS_REDUCER,
  DAILY_REPORT_REDUCER_KEY,
  VENDOR_EXLUSION_REDUCER_KEY,
  vendorExclusionReducer,
  orderStatusReducer,
  dailyReportReducer,
} from "../components/orderStatus/reducer";
import {
  REDUCER_KEY as ACCESSORY_REPLENISHMENT_REDUCER,
  accessoryReplenishmentReducer,
} from "../components/systemPreference/reducer";
import {
  REDUCER_KEY as KITS_MAINTENANCE_REDUCER,
  KIT_FRAME_REDUCER_KEY,
  kitFrameReducer,
  kitsMaintenanceReducer,
} from "src/components/kits/kitMaintenance/reducer";
import {
  ASSORTMENT_SKU_REDUCER_KEY,
  assortmentSkuReducer,
  REDUCER_KEY as FRAME_ARRANGER_QTY_REDUCER_KEY,
  frameArrangerQtyReducer,
} from "src/components/FrameArranger/FrameArrangerQty/reducer";
import {
  REDUCER_KEY as VENDOR_COLLECTION_MAPPING_REDUCER_KEY,
  vendorCollectionMappingReducer,
} from "src/components/FrameArranger/VendorsAndCollections/reducer";

import {
  REDUCER_KEY as PRODUCT_PLANOGRAM_REDUCER_KEY,
  productPlanogramMappingReducer,
} from "src/components/FrameArranger/ProductPlanogram/reducer";

import {
  REDUCER_KEY as OFFICE_COLLECTION_MAPPING_REDUCER_KEY,
  officeCollectionMappingReducer,
} from "src/components/FrameArranger/OfficeCollection/reducer";

import {
  REDUCER_KEY as VALIDATE_ACUITY_REDUCER,
  validateAcuityImportReducer,
} from "src/components/FrameArranger/ValidateAcuityFrameImport/reducer";
import {
  REDUCER_KEY as KIT_PROCESSING_REDUCER_KEY,
  AVAILABLE_OFFICE_REDUCER_KEY,
  SELECTED_OFFICE_REDUCER_KEY,
  kitProcessingReducer,
  availableOfficeReducer,
  selectedOfficeReducer,
} from "src/components/kits/KitProcessing/reducer";
import {
  fedexReducer,
  REDUCER_KEY as FEDEX_REDUCER_KEY,
} from "src/components/FedEx/Fedex/reducer";
import {
  expressOfficeReducer,
  REDUCER_KEY as EXPRESS_OFFICE_REDUCER_KEY,
} from "src/components/FedEx/ExpressOffices/reducer";
import permissionReducer from "src/components/navbar/reducer";

import {
  REDUCER_KEY as BULK_COST_UPDATE_REDUCER_KEY,
  bulkCostUpdateReducer,
} from "src/components/bulkCostUpdate/reducer";

import {
  REDUCER_KEY as OFFICE_REPLENISHMENT_PO_REDUCER_KEY,
  officeReplenishmentPOReducer,
} from "src/components/officeReplenishmentPO/reducer";

import {
  REDUCER_KEY as LOCATION_LIST_UPDATE_REDUCER_KEY,
  locationListUpdateReducer,
} from "src/components/inventotyAudit/LocationList/reducer"
import { REDUCER_KEY as INVENTORY_FINAL_UPDATE_REDUCER_KEY,
  InventoryFinalUpdateReducer } from "src/components/inventotyAudit/InventoryUpdate/reducer";
import { REDUCER_KEY as REPLENISHMENT_JOB_UPDATE_REDUCER_KEY, ReplenishmentJobUpdateReducer } from "src/components/ReplenishmentJobUpdate/reducer";
import { REDUCER_KEY as UNDO_INVENTORY_POST, InventoryPostLocationsReducer } from "../components/inventotyAudit/UndoInventoryPost/reducer";
import { REDUCER_KEY as FTP_FILE_TRANSFER_REDUCER_KEY, ftpFileTransferReducer } from "src/components/FtpFileTransfer/reducer";
import {
  ecomOrdersReducer,
  REDUCER_KEY as ECOM_ORDERS_REDUCER_KEY,
} from "src/components/ecomOrders/ecomOrders-reducer";

const rootReducer = combineReducers({
  [VENDOR_REDUCER]: vendorReducer,
  [PICKER_REDUCER_KEY]: pickerReducer,
  [PRINT_TAGS_REDUCER]: printTagsReducer,
  [OPEN_PULL_REDUCER]: openPullReducer,
  [FRAME_PICK_REDUCER]: framePickReducer,
  [SPECIAL_ORDER_QUEUE_REDUCER_KEY]: specialOrderQueueReducer,
  [DC_REPLENISHMENT_REDUCER]: replenishmentReducer,
  [VENDOR_ORDER_REDUCER]: vendorOrderReducer,
  [ORDER_STATUS_REDUCER]: orderStatusReducer,
  [DAILY_REPORT_REDUCER_KEY]: dailyReportReducer,
  [PENDING_ORDER_REDUCER_KEY]: pendingOrderReducer,
  [VENDOR_EXLUSION_REDUCER_KEY]: vendorExclusionReducer,
  [ACCESSORY_REPLENISHMENT_REDUCER]: accessoryReplenishmentReducer,
  [KITS_MAINTENANCE_REDUCER]: kitsMaintenanceReducer,
  [KIT_FRAME_REDUCER_KEY]: kitFrameReducer,
  [FRAME_ARRANGER_QTY_REDUCER_KEY]: frameArrangerQtyReducer,
  [VENDOR_COLLECTION_MAPPING_REDUCER_KEY]: vendorCollectionMappingReducer,
  [PRODUCT_PLANOGRAM_REDUCER_KEY]: productPlanogramMappingReducer,
  [OFFICE_COLLECTION_MAPPING_REDUCER_KEY]: officeCollectionMappingReducer,
  [VALIDATE_ACUITY_REDUCER]: validateAcuityImportReducer,
  [KIT_PROCESSING_REDUCER_KEY]: kitProcessingReducer,
  [AVAILABLE_OFFICE_REDUCER_KEY]: availableOfficeReducer,
  [SELECTED_OFFICE_REDUCER_KEY]: selectedOfficeReducer,
  [FEDEX_REDUCER_KEY]: fedexReducer,
  [ASSORTMENT_SKU_REDUCER_KEY]: assortmentSkuReducer,
  [EXPRESS_OFFICE_REDUCER_KEY]: expressOfficeReducer,
  [BULK_COST_UPDATE_REDUCER_KEY]: bulkCostUpdateReducer,
  [OFFICE_REPLENISHMENT_PO_REDUCER_KEY]: officeReplenishmentPOReducer,
  [LOCATION_LIST_UPDATE_REDUCER_KEY]: locationListUpdateReducer,
  [INVENTORY_FINAL_UPDATE_REDUCER_KEY]: InventoryFinalUpdateReducer,
  [REPLENISHMENT_JOB_UPDATE_REDUCER_KEY]: ReplenishmentJobUpdateReducer,
  [UNDO_INVENTORY_POST]: InventoryPostLocationsReducer,
  [FTP_FILE_TRANSFER_REDUCER_KEY]: ftpFileTransferReducer,
  [ECOM_ORDERS_REDUCER_KEY]: ecomOrdersReducer,
  MenuPermissionData: permissionReducer,
});

export default rootReducer;
